<div class="card success-card" [style]="'z-index:9999;border-left:5px solid'+ popUpMessage?.borderColor">
  <div class="card-body">
    <div class="d-flex justify-content-between">
      <i [innerHTML]="popUpMessage?.icon | safe"></i>
      <i *ngIf="popUpMessage?.closeIcon"[innerHTML]="popUpMessage?.closeIcon | safe" (click)="onClose()" class="close-icon"></i>
    </div>
      <p>{{popUpMessage?.message}} <a *ngIf="popUpMessage?.url" (click)="onclick()">here.</a></p>
  </div>
</div>